import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { ReactComponent as Success } from "../../assets/images/success.svg";
import { ReactComponent as Failed } from "../../assets/images/failed.svg";
import { sendReceipt } from "../../services/monobank";
import { SEO } from "../../components/SEO/SEO";

export const PaypalReturn = () => {
  const [searchParams] = useSearchParams();
  const status = searchParams.get("status");
  const invoiceId = searchParams.get("invoiceId") || "";

  const [receiptSent, setReceiptSent] = useState(false);

  const { t } = useTranslation();

  useEffect(() => {
    localStorage.removeItem("invoiceLink");
    localStorage.removeItem("invoiceId");

    if (status === "success") {
      localStorage.removeItem("userCartColors");
      localStorage.removeItem("userCartId");
      localStorage.removeItem("userCartIds");
      localStorage.removeItem("userCartQuantities");
      localStorage.removeItem("userCartSizes");
      localStorage.removeItem("userCartTypes");
      localStorage.removeItem("userCartLimits");
    }
  }, [status]);

  const onGetReceiptButtonClick = async () => {
    if (receiptSent) {
      return;
    }
    await sendReceipt(invoiceId);
    setReceiptSent(true);
    toast(t("ProcessingReceiptSent"), {
      className: "toast__success",
      bodyClassName: "toast__body",
      progressClassName: "toast__progressBar--success",
    });
  };

  return (
    <>
      <SEO title="PayPal" noIndex />
      <div className="processing__backdrop">
        <div className="processing__modal">
          {status === "success" ? (
            <>
              <Success className="processing__icon" />
              <div>
                <p className="processing__status--text green">
                  {t("ProcessingSuccessTitle")}
                </p>
                <p className="processing__status--text white">
                  {t("ProcessingSuccessThanks")}
                </p>
              </div>
              <div className="processing__buttons--wrapper">
                <Link to="/" className="processing__button small">
                  {t("ProcessingSuccessButtonFirst")}
                </Link>
                <button
                  type="button"
                  className="processing__button small"
                  onClick={onGetReceiptButtonClick}
                >
                  {t("ProcessingSuccessButtonSecond")}
                </button>
              </div>
            </>
          ) : (
            <>
              <Failed className="processing__icon" />
              <div>
                <p className="processing__status--text red">
                  {status === "cancelled"
                    ? t("ProcessingCancelledTitle")
                    : t("ProcessingErrorTitle")}
                </p>
                <p className="processing__status--text white">
                  {t("ProcessingErrorTryAgain")}
                </p>
              </div>
              <div className="processing__buttons--wrapper">
                <Link to="/cart" className="processing__button small">
                  {t("ProcessingErrorButtonFirst")}
                </Link>
                <Link to="/" className="processing__button small">
                  {t("ProcessingErrorButtonSecond")}
                </Link>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};
